
<app-badge palette="rose" *ngIf="permission && permission.is_admin == true">Admin</app-badge>
<app-badge palette="slate" *ngIf="!permission || permission.is_admin == false">User</app-badge>
